export default class AgreementModel {
  id: string;
  availableForAllOfferings: boolean = false;
  enabledByDefault: boolean = true;
  title: string = "";
  description: string = "";
  order: number = 0;
  required: boolean = false;

  constructor(data: AgreementModel | {}) {
    Object.assign(this, data);
  }
}
